import { render, staticRenderFns } from "./IconSedan.vue?vue&type=template&id=2394523a"
import script from "./IconSedan.vue?vue&type=script&lang=js"
export * from "./IconSedan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports